import React, { SVGProps } from 'react'
export const WalletSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path fill="#2E2A29" d="M21 14.783a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
    <path
      fill="#2E2A29"
      fillRule="evenodd"
      d="M2 17.283v-6c0-1.84 1.243-3.39 2.935-3.856l7.795-4.084a3 3 0 0 1 4.076 1.316l1.313 2.626A4 4 0 0 1 22 11.283v.5h-2.5a3 3 0 1 0 0 6h2.47a4 4 0 0 1-3.97 3.5H6a4 4 0 0 1-4-4ZM13.658 5.115a1 1 0 0 1 1.359.438l.865 1.73H9.519l4.14-2.168Z"
      clipRule="evenodd"
    />
  </svg>
)
